import { gql } from '@apollo/client';

/**
 * AOI 类型字典 - 前端下拉级联用。
 *
 * <p>后端按 enum 声明顺序返回, 一级在前, 二级紧跟父级。前端按 parentCode 自行做级联展开。
 */
export const LIST_AOI_TYPE_DICTIONARY = gql`
  query ListAoiTypeDictionary {
    listAoiTypeDictionary {
      code
      zhName
      parentCode
      isRoot
      isLeaf
    }
  }
`;

export interface AoiTypeDictItem {
  code: string;
  zhName: string;
  parentCode: string | null;
  isRoot: boolean;
  isLeaf: boolean;
}

export interface ListAoiTypeDictionaryResponse {
  listAoiTypeDictionary: AoiTypeDictItem[];
}
